import React from "react";
import { getElementPreset } from "@/components/section-seating/element-types";

interface PlanElementBoxProps {
  type: string;
  label: string | null;
  color: string;
  width: number;
  height: number;
  cell: number;
}

export function PlanElementBox({ type, label, color, width, height, cell }: PlanElementBoxProps) {
  const preset = getElementPreset(type);
  const text = label || preset.label;
  const vertical = height > width;
  return (
    <div
      className="w-full h-full rounded-md border-2 flex items-center justify-center gap-1.5 overflow-hidden"
      style={{
        borderColor: color,
        backgroundColor: `${color}26`,
        flexDirection: vertical ? "column" : "row",
      }}
    >
      <preset.icon className="shrink-0" style={{ color, width: Math.min(cell * 0.6, 20), height: Math.min(cell * 0.6, 20) }} />
      <span className="text-[10px] font-bold tracking-wider uppercase" style={{ color, writingMode: vertical ? "vertical-rl" : undefined }}>
        {text}
      </span>
    </div>
  );
}
